export class BaseController {
  /**
   * We make AppService nullable to make it backwards compatible.
   * 
   * @param {AppService} AppService 
   */
  constructor(AppService = null) {
    this.AppService = AppService;

    this.state = {};
    this._subscriptions = [];
  }

  /**
   * Broadcast a scope event to all siblings scope.
   * 
   * @param {string} name - The name of the event to be broadcasted to siblings scope.
   */
  broadcast(name) {
    this.AppService.broadcast(name);
  }

  /**
   * Adds listener to EventDispatcherService.
   * 
   * @param {string} eventName - Name of the event to listen to
   * @param {function} callback - Function to invoke when the specified event is emitted
   */
  addListener(eventName, callback) {
    const subscription = this.AppService.addListener(eventName, callback);

    this.addSubscription(subscription);
  }

  setState(key, val) {
    this.state[key] = val;
  }

  getState(key) {
    return this.state[key];
  }

  addSubscription(subscription) {
    this._subscriptions.push(subscription);
  }

  removeSubscriptions() {
    this._subscriptions.forEach(subscription => subscription.remove());
    this._subscriptions.length = 0;
  }

  getSession() {
    const sessionService = this.AppService.get('SessionService');

    return sessionService.getSession();
  }

  setSessionItem(key, value) {
    const sessionService = this.AppService.get('SessionService');
    
    sessionService.set(key, value);
  }

  goToState(state, params) {
    const $state = this.AppService.get('$state', params);

    $state.go(state, params);
  }

  // Override this when you need to have
  // more sophisticated onDestroy() logic.
  // but do not forget to call super.$onDestroy();
  $onDestroy() {
    this.removeSubscriptions();
  }
}



// WEBPACK FOOTER //
// ./client/app/shared/basecontroller.controller.js